import { render, staticRenderFns } from "./EditBalance.vue?vue&type=template&id=3e8336b7&scoped=true&"
import script from "./EditBalance.vue?vue&type=script&lang=js&"
export * from "./EditBalance.vue?vue&type=script&lang=js&"
import style0 from "./EditBalance.vue?vue&type=style&index=0&id=3e8336b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8336b7",
  null
  
)

export default component.exports